import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../customAxios.js";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import "../assets/stylesheets/mailings.scss";

function MailingConfig() {
  const { state } = useLocation();
  const mailId = state.mailId;
  const mailStatus = state.mailStatus;
  const translatedDeliverySystem = state.translatedDeliverySystem;
  const [loading, setLoading] = useState(true);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [customizationOptions, setCustomizationOptions] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true);
    let data = {
      subject: subject,
      body: body,
    };
    try {
      await axios.put(`mails/update_mail_text/${mailId}/`, data);
      setLoading(false);
      navigate(-1);
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchMail = async () => {
    setLoading(true);
    try {
      const {
        data: { subject, body, customization_options },
      } = await axios.get(`mails/get_mail/${mailId}/`);
      setSubject(subject || "");
      setBody(body || "");
      setCustomizationOptions(customization_options || {});
    } catch (error) {
      console.error(`Fallo al obtener el mail: ${error.response || error}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMail();
  }, []);

  const appendAttributeToSubject = (attribute_name) => {
    setSubject(`${subject} {${attribute_name}}`);
  };

  const appendAttributeToBody = (attribute_name) => {
    setBody(`${body} {${attribute_name}}`);
  };

  return (
    <>
      {loading ? (
        <CircularProgress className="" />
      ) : (
        <>
          <Grid container className="mailing-container">
            <Grid item xs={6} sm={6} className="flex-left">
              <h1>Configuración mailing</h1>
            </Grid>
            <Grid item xs={12}>
              <h6 className="subtitle">Notificaciones al cliente final</h6>
              <div className="mailing-description-data">
                <p>
                  <strong>Estado</strong>: {mailStatus}
                </p>
                <p>
                  <strong>Tipo de orden</strong>: {translatedDeliverySystem}
                </p>
              </div>
            </Grid>
            <Grid item xs={12} className="flex-center">
              <TextField
                variant="outlined"
                label="Asunto"
                name="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="mailing-textfield-input"
              />
            </Grid>

            <Grid
              item
              xs={12}
              className="flex-center customization-options-container"
            >
              <label>Inserta información personalizada al asunto</label>
              <div>
                {Object.entries(customizationOptions).map(([key, value]) => (
                  <Button
                    key={key}
                    variant="outlined"
                    onClick={() => appendAttributeToSubject(key)}
                  >
                    {value}
                  </Button>
                ))}
              </div>
            </Grid>

            <Grid item xs={12} className="flex-center">
              <TextField
                multiline
                variant="outlined"
                label="Mensaje"
                name="body"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                className="mailing-textfield-input multiline-textfield"
              />
            </Grid>

            <Grid
              item
              xs={12}
              className="flex-center customization-options-container"
            >
              <label>Inserta información personalizada al mensaje</label>
              <div>
                {Object.entries(customizationOptions).map(([key, value]) => (
                  <Button
                    key={key}
                    variant="outlined"
                    onClick={() => appendAttributeToBody(key)}
                  >
                    {value}
                  </Button>
                ))}
              </div>
            </Grid>

            <Grid item xs={12} className="flex-center mg-t-20">
              <Grid container className="mailing-delete-container">
                <Grid item xs={12} className="flex-left">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setBody("");
                    }}
                  >
                    <i className="material-icons-outlined">cancel</i>
                    <p className="mg-0 pd-l-10">Borrar email</p>
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className="flex-center mg-t-30 mg-b-30">
              <Button
                className="mg-r-15"
                disabled={loading}
                variant="outlined"
                onClick={() => navigate(-1)}
              >
                Volver atrás
              </Button>
              <Button
                className="mg-l-15"
                disabled={loading}
                variant="contained"
                onClick={() => handleSubmit()}
              >
                {loading ? (
                  <CircularProgress className="loading-btn" />
                ) : (
                  "Guardar email"
                )}
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}

export default MailingConfig;
